import { render, h } from 'preact'
import './Icon.scss';
const Icon = (props)=>{
    var { 
        style = {},
        icon = "md-home",
        // className = "",
        class:className
    } = props;
    return (
        <div 
            className={`ion ion-${icon} ${className}`}
            style={style}
        ></div>
    );
}

export default Icon;